import AppComponent from './app_component'

export default class TagComponent extends AppComponent {

  addToTagList = (tag, tagged_item) => {
    tagged_item.tag_list.push(tag)
   
    var params = {
      id: tagged_item.id,
      tag_list: tagged_item.tag_list
    }

    this.props.updateTags(params)
  }

  addToRegionList = (tag, tagged_item) => {
    tagged_item.region_list.push(tag)
  
    var params = {
      id: tagged_item.id,
      region_list: tagged_item.region_list
    }

    this.props.updateTags(params)
  }

  removeFromTagList = (tag, tagged_item) => {
    tagged_item.tag_list = tagged_item.tag_list.filter((item) => { return item !== tag; });

    var params = {
      id: tagged_item.id,
      tag_list: tagged_item.tag_list
    }

    this.props.updateTags(params)
  }

  removeFromRegionList = (tag, tagged_item) => {
    tagged_item.region_list = tagged_item.region_list.filter((item) => { return item !== tag; });
   
    var params = {
      id: tagged_item.id,
      region_list: tagged_item.region_list
    }

    this.props.updateTags(params)
  }

  render() {
    return
  }
}



// WEBPACK FOOTER //
// ./src/views/components/tag_component.js